import { render, staticRenderFns } from "./userAuthNew.vue?vue&type=template&id=7b906d65&scoped=true"
import script from "./userAuthNew.vue?vue&type=script&lang=js"
export * from "./userAuthNew.vue?vue&type=script&lang=js"
import style0 from "./userAuthNew.vue?vue&type=style&index=0&id=7b906d65&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b906d65",
  null
  
)

export default component.exports